export default {
  user: null,
  miniLoading: false,
  breakpoint: {},
  searchImageGoodsList: [],
  snackbar: {
    color: 'success',
    show: false,
    text: '',
    icon: '',
    timeout: 3000,
  },
  // snackbarColor: "success",
  // snackbarShow: false,
  // snackbarText: "",
  // snackbarIcon: "",
  breadCrumbs: [],
  countries: {
    status: 0,
    data: [],
  },
  hotSearch: {
    status: 0,
    data: [],
  },
  adList: {
    status: 0,
    data: [],
  },
  bannerList: {
    status: 0,
    data: [],
  },
  categories: {
    status: 0,
    data: [],
  },
  tagGoods: {
    // type: 2
    newArrivals: {
      status: 0,
      data: [],
      currentPage: 1,
    },
    // type: 3
    bestSellers: {
      status: 0,
      data: [],
      currentPage: 1,
    },
    // type: 4
    recommends: {
      status: 0,
      data: [],
      currentPage: 1,
    },
    // type: 5
    promotions: {
      status: 0,
      data: [],
      currentPage: 1,
    },
  },
  goodsPopular: {
    status: 0,
    data: [],
  },
  webConfig: {
    countryList: [],
  },
  usedCountry: null,
  newsList: {
    status: 0,
    data: {
      items: [],
      p: 1,
    },
  },
  language: {
    text: 'الإنجليزية',
    textEn: 'English',
    value: '2',
  },
};
